import type { Result } from '../../types/results';

/**
 * Pro discipliny s vice pokusy zredukuje seznam na NEJLEPSI pokus per druzstvo.
 * Pravidlo Plamen: poradi tvori nejlepsi platny cas z povolenych pokusu.
 *
 * Pro disciplíny s attemptsCount=1 ponecha vstup nezmeneny (per team jen 1 zaznam).
 */
export const bestAttemptPerTeam = (results: Result[]): Result[] => {
  const best = new Map<number, Result>();
  for (const r of results) {
    const existing = best.get(r.teamId);
    if (!existing) {
      best.set(r.teamId, r);
      continue;
    }
    const existingValid = !existing.isNp && existing.timeFinalMs != null && existing.timeFinalMs > 0;
    const newValid = !r.isNp && r.timeFinalMs != null && r.timeFinalMs > 0;
    if (newValid && !existingValid) {
      best.set(r.teamId, r);
    } else if (newValid && existingValid && r.timeFinalMs! < existing.timeFinalMs!) {
      best.set(r.teamId, r);
    }
  }
  return [...best.values()];
};
